import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { ToastMessages } from "../../../components/toasts/toastMessages";
import { uploadClinicalAttachmentToFirebase } from "./uploadClinicalAttachmentToFirebase";

interface UploadClinicalAttachmentWithToastParams {
  mergedFile: Blob;
  orderId: string;
  onLoadingChange?: (isLoading: boolean) => void;
}

/**
 * Uploads a clinical attachment to Firebase and shows toast notifications
 * for success or failure.
 *
 * Delegates to {@link uploadClinicalAttachmentToFirebase} and wires up
 * toast messages automatically.
 *
 * @param params - Upload configuration
 * @param params.mergedFile - The PDF blob to upload.
 * @param params.orderId - The medical PA order ID.
 * @param params.onLoadingChange - Called with `true` when the upload starts
 *   and `false` when it completes (regardless of outcome).
 */
export const uploadClinicalAttachmentWithToast = async ({
  mergedFile,
  orderId,
  onLoadingChange,
}: UploadClinicalAttachmentWithToastParams): Promise<void> => {
  await uploadClinicalAttachmentToFirebase({
    mergedFile,
    orderId,
    onSuccess: () => {
      toast.success(ToastMessages.CLINICAL_ATTACHMENT_UPLOADED_SUCCESS);
    },
    onFailure: () => {
      toast.error(ToastMessages.CLINICAL_ATTACHMENT_UPLOADED_ERROR);
    },
    onLoadingChange,
  });
};
